module.exports = __webpack_public_path__ + "static/media/Hours_19-24.ddc58006.png";